module.exports = __webpack_public_path__ + "img/ES.45d0d1b7.svg";